export default __webpack_public_path__ + "static/media/eye-off.d19b0423.svg";